class Storage {
	auth = {
		get token(): string | null {
			return localStorage.getItem('JK_ACCESS_TOKEN')
		},
		set token(value: string | null) {
			if (value === null) {
				localStorage.removeItem('JK_ACCESS_TOKEN')
				return
			}
			localStorage.setItem('JK_ACCESS_TOKEN', value)
		},
		get refreshToken(): string | null {
			return localStorage.getItem('JK_REFRESH_TOKEN')
		},
		set refreshToken(value: string | null) {
			if (value === null) {
				localStorage.removeItem('JK_REFRESH_TOKEN')
				return
			}
			localStorage.setItem('JK_REFRESH_TOKEN', value)
		},
		get deviceId(): string | null {
			return localStorage.getItem('JK_DEVICE_ID')
		},
		set deviceId(value: string | null) {
			if (value === null) {
				localStorage.removeItem('JK_DEVICE_ID')
				return
			}
			localStorage.setItem('JK_DEVICE_ID', value)
		},
	}

	get lastShowWhatsNewVersion(): string | null {
		return localStorage.getItem('LAST_SHOW_WHATS_NEW_VERSION')
	}
	set lastShowWhatsNewVersion(value: string | null) {
		if (value === null) {
			localStorage.removeItem('LAST_SHOW_WHATS_NEW_VERSION')
			return
		}
		localStorage.setItem('LAST_SHOW_WHATS_NEW_VERSION', value)
	}
}

const storage = new Storage()

export default storage
